<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-change-photo scrollable -y">
      <div class="header">
        <div class="title">Change Photo</div>
      </div>

      <transition name="flyInH" mode="out-in">

        <div
        v-if="selectedTab === 'takePhoto'"
        v-bind:key="'takePhoto'"
        class="body">
          <div class="content">
            <div class="photo-container">
              <div
              v-bind:style="{
                'display': newSnapshotURLFromCamera ? 'none' : null
              }"
              class="profile-photo" ref="webcam"></div>
              <div
              v-bind:style="{
                'display': newSnapshotURLFromCamera ? null : 'none'
              }"
              class="profile-photo">
                <img v-bind:src="newSnapshotURLFromCamera" />
              </div>
            </div>
            <div class="action-btns column">
              <template v-if="newSnapshotURLFromCamera">
                <div
                v-on:click="onClickTryAgain()" ontouchstart=""
                class="action-btn">Try again</div>
                <div
                v-on:click="onClickLooksGood()" ontouchstart=""
                class="action-btn blue">Looks good!</div>
              </template>
              <template v-else>
                <div
                v-on:click="takeSnapshot()" ontouchstart=""
                class="action-btn blue">Snap a photo</div>
                <div class="action-btn disabled">Smile!</div>
              </template>
              <div
              v-on:click="goToUploadPhotoTab()" ontouchstart=""
              class="action-btn">Cancel</div>
            </div>
          </div>
        </div>

        <form
        v-else
        v-bind:key="'uploadPhoto'"
        v-on:submit="onClickSubmit"
        class="body">
          <div class="content">
            <div class="photo-container">
              <div class="profile-photo">
                <template v-if="!newSnapshotURL">
                  <template v-if="myProfilePictureUrl">
                    <img v-bind:src="myProfilePictureUrl" />
                  </template>
                  <template v-else>
                    <div class="no-photo">No photo</div>
                  </template>
                </template>
                <template v-else>
                  <img v-bind:src="newSnapshotURL" />
                </template>
              </div>
            </div>
            <div class="action-btns flex-around">
              <div
              v-on:click="openFileBrowser()" ontouchstart=""
              class="action-btn">Choose</div>
              <div
              v-on:click="goToTakePhotoTab()" ontouchstart=""
              class="action-btn">Take a photo</div>
              <div
              v-on:click="onClickRemove()" ontouchstart=""
              class="action-btn">Remove</div>
            </div>
            <div
            style="border-top: 1px solid hsla(0, 100%, 0%, 0.1);"
            class="action-btns flex-end">
              <div
              v-on:click="closeModalRequest()" ontouchstart=""
              class="action-btn">Cancel</div>
              <input
              id="update-name"
              type="submit" value="Update"
              class="action-btn blue" />
            </div>
          </div>
        </form>

      </transition>

    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-change-photo',
  components: {
    Modal
  },
  computed: {
    myProfilePictureUrl: function () {
      return this.$store.getters.myProfilePictureUrl
    }
  },
  data: function () {
    return {
      selectedTab: 'uploadPhoto',
      tabs: ['uploadPhoto', 'takePhoto'],
      camera: null,
      newSnapshotURL: null,
      newSnapshotURLFromCamera: null,
      imageFile: {
        blobData: null,
        contentType: null
      },
      imageFileFromCamera: {
        blobData: null,
        contentType: null
      }
    }
  },
  beforeDestroy: function () {
    this.stopJpegCamera()
    this.removeSnapshot()
  },
  methods: {
    closeModalRequest: function (reload = false) {
      this.$emit('closeModalRequest')
      if (reload) setTimeout(() => { this.getMyProfile() }, 1000)
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      let blobData = this.imageFile.blobData
      let contentType = this.imageFile.contentType
      if (blobData && contentType) {
        this.uploadMyAvatar().then(
          success => {
            this.closeModalRequest(true)
          },
          failure => {
            this.closeModalRequest()
          }
        )
      } else {
        this.closeModalRequest(true)
      }
    },
    goToTakePhotoTab: function () {
      this.selectedTab = 'takePhoto'
      this.initJpegCamera()
    },
    goToUploadPhotoTab: function () {
      this.selectedTab = 'uploadPhoto'
      this.stopJpegCamera()
      this.removeSnapshot()
    },
    initJpegCamera: function () {
      if (this.$refs.webcam) {
        this.startJpegCamera()
      } else {
        setTimeout(() => {
          this.startJpegCamera()
        }, 1000)
      }
    },
    startJpegCamera: function () {
      if (this.$refs.webcam) {
        let options = {
          quality: 1,
          shutter: false,
          mirror: true,
          timeout: 0,
          retry_success: false,
          scale: 0.4
        }
        this.camera = new this.$jpegCamera(this.$refs.webcam, options).ready((info) => {
          // console.log(info)
        })
      }
    },
    takeSnapshot: function () {
      let snapshot = this.camera.capture()
      let contentType = 'image/jpeg'
      snapshot.get_blob(function (data) {
        this.newSnapshotURLFromCamera = window.URL.createObjectURL(data)
        this.imageFileFromCamera.blobData = data
        this.imageFileFromCamera.contentType = contentType
      }.bind(this), contentType)
    },
    removeSnapshot: function () {
      this.newSnapshotURLFromCamera = null
      this.imageFileFromCamera.blobData = null
      this.imageFileFromCamera.contentType = null
    },
    onClickTryAgain: function () {
      this.removeSnapshot()
    },
    onClickLooksGood: function () {
      this.newSnapshotURL = this.newSnapshotURLFromCamera
      this.imageFile.blobData = this.imageFileFromCamera.blobData
      this.imageFile.contentType = this.imageFileFromCamera.contentType
      this.goToUploadPhotoTab()
    },
    onClickRemove: function () {
      this.newSnapshotURL = null
      this.imageFile.blobData = null
      this.imageFile.contentType = null
    },
    stopJpegCamera: function () {
      if (this.camera) {
        this.camera.stop_stream()
        this.$refs.webcam.innerHTML = ''
        this.camera = null
      }
    },
    openFileBrowser: function () {
      let x = document.createElement('INPUT')
      x.setAttribute('type', 'file')
      x.setAttribute('accept', 'image/*;capture=camera')
      x.onchange = function (event) {
        let file = event.target.files[0]
        let contentType = file['type']

        let reader = new FileReader()
        reader.onload = function () {
          let imageBlobData = reader.result
          this.newSnapshotURL = (window.URL || window.webkitURL).createObjectURL(file)
          this.imageFile.blobData = imageBlobData
          this.imageFile.contentType = contentType
        }.bind(this)

        if (file) {
          reader.readAsArrayBuffer(file)
        }
      }.bind(this)
      x.click()
    },
    getMyProfile: function () {
      return this.$store.dispatch('getMyProfile')
    },
    uploadMyAvatar: function () {
      let blobData = this.imageFile.blobData
      let contentType = this.imageFile.contentType
      return this.$store.dispatch('uploadMyAvatar', {blobData, contentType})
    }
  }
}
</script>

<style scoped>
.modal-change-photo {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  border: 1px solid var(--blue-gray-medium);
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
  /* position */
  position: relative;
}

.modal-change-photo .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-change-photo .header .title {
  /* common */
  font-size: 2em;
}
.modal-change-photo .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-change-photo .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-change-photo .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-change-photo .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-change-photo .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-change-photo .body .content .info-container > input {
  /* common */
  background-color: hsla(0, 100%, 0%, 0.1);
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
}





.modal-change-photo .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.modal-change-photo .body .content .action-btns.column {
  /* alignment */
  display: flex;
  flex-direction: column;
  text-align: center;
}
.modal-change-photo .body .content .action-btn {
  /* common */
  background-color: white;
  color: var(--gray-high);
  white-space: nowrap;
  border: 1px solid var(--border);
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  /* size */
  width: auto;
  padding: 0.5em 1em;
  margin-right: 1em;
  /* padding: 5px 10px 5px 5px; */
  margin-top: 1em;
  /* mouse */
  cursor: pointer;
}
.modal-change-photo .body .content .action-btn.blue {
  /* common */
  background-color: var(--primary);
  color: #fff;
}
.modal-change-photo .body .content .action-btn.disabled {
  /* common */
  background-color: hsla(202, 0%, 100%, 1);
  color: hsla(202, 0%, 50%, 1);
  /* mouse */
  pointer-events: none;
}


.modal-change-photo .body .content .photo-container {
  /* common */
  background-color: hsla(0, 0%, 95%, 1);
  /* size */
  width: 100%;
  height: 200px;
  /* border */
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.modal-change-photo .body .content .photo-container .profile-photo {
  /* common */
  background-color: hsla(0, 0%, 0%, 1);
  color: #fff;
  overflow: hidden;
  /* size */
  width: 200px;
  height: 200px;
  /* border */
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.modal-change-photo .body .content .photo-container .profile-photo > img {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  z-index: 1;
}

.flex-around {
  justify-content: space-around;
}
.flex-end {
  justify-content: end;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalChangePhoto.vue